export { default } from './ContainerHome24';
